import { create } from 'zustand';
import axios from 'axios';

const useCategoryStore = create((set) => ({
    categories: [],
    loading: false,
    error: null,
    canWrite: false, // Track if management APIs are available
    fetchCategories: async () => {
        set({ loading: true, error: null });
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get('/api/categories', { headers: { Authorization: `Bearer ${token}` } });
            set({ categories: res.data || [] });

            // Heuristic check: if this works, we assume read is ok.
            // We'll determine canWrite later based on first POST/PUT attempt or explicit check.
        } catch (e) {
            console.error('Failed to load categories', e);
            set({ error: 'Categories unavailable' });
        } finally {
            set({ loading: false });
        }
    }
}));

export default useCategoryStore;
